<template>
  <div class="col-12 page_content_area">
    <div class="container">
      <navigation
        :list="segments"
        :active-value="activeSegment"
        variety="underline"
        @active:updated="tapNavigation"
      />
      <component :is="activeSegmentComponent" :current-student="currentStudentGetter"/>
    </div>
  </div>
</template>
<script>
import Navigation from '~components/common/Navigation'
import ObtainRecord from '~components/pages/point/nested/ObtainRecord'
import ExchangeRecord from '~components/pages/point/nested/ExchangeRecord'
import RedeemableList from '~components/pages/point/nested/RedeemableList'
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'PointContent',
  components: {
    Navigation,
    ObtainRecord,
    ExchangeRecord,
    RedeemableList
  },
  data () {
    return {
      segments: ['獲得紀錄', '兌換紀錄', '可兌換列表'],
      segmentComponents: [ObtainRecord, ExchangeRecord, RedeemableList],
      activeSegment: '獲得紀錄'
    }
  },
  computed: {
    ...mapGetters('pages/students', [
      'currentStudentGetter'
    ]),
    activeSegmentComponent () {
      return this.segmentComponents[this.segments.indexOf(this.activeSegment)]
    },
  },
  created () {
    const specificSegment = this.$route.query.tab
    if (specificSegment) {
      this.updateActiveSegment(specificSegment)
    }
  },
  methods: {
    tapNavigation (segment) {
      this.updateActiveSegment(segment)
      this.pushTabQuery(segment)
    },
    pushTabQuery (segment, sub) {
      if (sub) {
        this.$router.push({
          path: '/point',
          query: {
            tab: segment,
            sub
          }
        })
      } else {
        this.$router.push({
          path: '/point',
          query: {
            tab: segment
          }
        })
      }
    },
    updateActiveSegment (segment) {
      this.activeSegment = segment
    }
  },
}
</script>